import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./AuthContext";
import { CartProvider } from "./CartContext";
import { SettingsProvider } from "./SettingsContext";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import BuyerLayout from "./components/BuyerLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Terms from "./pages/Terms";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Products from "./pages/admin/Products";
import ProductEdit from "./pages/admin/ProductEdit";
import Categories from "./pages/admin/Categories";
import SizeOptions from "./pages/admin/SizeOptions";
import TierTemplates from "./pages/admin/TierTemplates";
import Countries from "./pages/admin/Countries";
import BuyerProfile from "./pages/admin/BuyerProfile";
import Parents from "./pages/admin/Parents";
import Buyers from "./pages/admin/Buyers";
import Dashboard from "./pages/admin/Dashboard";
import AdminOrders from "./pages/admin/Orders";
import AdminOrderDetail from "./pages/admin/OrderDetail";
import PackingList from "./pages/admin/PackingList";
import StockView from "./pages/admin/StockView";
import StockLogs from "./pages/admin/StockLogs";
import Outbox from "./pages/admin/Outbox";
import AdminSettings from "./pages/admin/Settings";
import CsvImport from "./pages/admin/CsvImport";
import Availability from "./pages/admin/Availability";
import BuyerActionConfirm from "./pages/BuyerActionConfirm";
import Catalog from "./pages/buyer/Catalog";
import ProductDetail from "./pages/buyer/ProductDetail";
import Cart from "./pages/buyer/Cart";
import Orders, { OrderDetail, OrderPrint } from "./pages/buyer/Orders";
import Profile from "./pages/buyer/Profile";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <SettingsProvider>
          <AuthProvider>
            <CartProvider>
              <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/admin/buyer-action/:token" element={<BuyerActionConfirm />} />

              {/* Admin */}
              <Route
                path="/admin"
                element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}
              >
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="orders/:id" element={<AdminOrderDetail />} />
                <Route path="products" element={<Products />} />
                <Route path="products/new" element={<ProductEdit />} />
                <Route path="products/:id" element={<ProductEdit />} />
                <Route path="stock" element={<StockView />} />
                <Route path="stock-logs" element={<StockLogs />} />
                <Route path="csv" element={<CsvImport />} />
                <Route path="availability" element={<Availability />} />
                <Route path="outbox" element={<Outbox />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="categories" element={<Categories />} />
                <Route path="sizes" element={<SizeOptions />} />
                <Route path="tiers" element={<TierTemplates />} />
                <Route path="countries" element={<Countries />} />
                <Route path="buyers" element={<Buyers />} />
                <Route path="buyers/:id" element={<BuyerProfile />} />
                <Route path="parents" element={<Parents />} />
              </Route>
              {/* Admin standalone (packing list, print pages) */}
              <Route path="/admin/orders/:id/packing-list" element={<ProtectedRoute role="admin"><PackingList /></ProtectedRoute>} />

              {/* Buyer storefront */}
              <Route
                element={<ProtectedRoute role="buyer"><BuyerLayout /></ProtectedRoute>}
              >
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/catalog/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/orders/:id" element={<OrderDetail />} />
                <Route path="/profile" element={<Profile />} />
              </Route>
              {/* Buyer standalone print */}
              <Route path="/orders/:id/print" element={<ProtectedRoute role="buyer"><OrderPrint /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
              </BrowserRouter>
            </CartProvider>
          </AuthProvider>
        </SettingsProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
